module.exports = __webpack_public_path__ + "img/brand5.663d1cb4.png";